<template>
  <article>
    <h1>移动家庭医生工作室进社区</h1>
<!--    <img src="../../static/images/newsDetail/1.jpg" alt="news">-->
<!--    <img src="https://s1.ax1x.com/2022/04/01/qh4JYj.jpg" alt="news1">-->
    <img :src="img_src.new1" alt="news1">
    <p>
      为进一步完善“15分钟健康服务圈”，有效支撑家庭医生团队服务下沉，提高社区居民对公益性服务的感受度。2019年11月15日，南京市鼓楼区华侨路社区卫生服务中心移动家庭医生工作室在清凉山庄小区广场开展家庭医生个性化签约健康服务免费体检。活动现场，移动家庭医生工作室工作人员为老年人、行动不便居民提供义诊义检，同时现场为自愿签约群众进行家庭医生现场签约、提供相关服务，并为居民发放家庭医生签约服务宣传资料和基本公共卫生服务资料。
    </p>
<!--    <img src="../../static/images/newsDetail/2.jpg" alt="news">-->
<!--    <img src="https://s1.ax1x.com/2022/04/01/qh4Ulq.jpg" alt="news2">-->
    <img :src="img_src.new2" alt="news2">


<!--    <img src="../../static/images/newsDetail/3.jpg" alt="news">-->
<!--    <img src="https://s1.ax1x.com/2022/04/01/qh4B0U.jpg" alt="news3">-->
    <img :src="img_src.new3" alt="news3">


<!--    <img src="../../static/images/newsDetail/4.jpg" alt="news">-->
<!--    <img src="https://s1.ax1x.com/2022/04/01/qh4D7F.jpg" alt="news4">-->
    <img :src="img_src.new4" alt="news4">

<!--    <img src="../../static/images/newsDetail/5.jpg" alt="news">-->
<!--    <img src="https://s1.ax1x.com/2022/04/01/qh4sk4.jpg" alt="news5">-->
    <img :src="img_src.new5" alt="news5">


<!--    <img src="../../static/images/newsDetail/6.jpg" alt="news6">-->
<!--    <img src="https://s1.ax1x.com/2022/04/01/qh40mT.jpg" alt="news6">-->
    <img :src="img_src.new6" alt="news6">
  </article>
</template>

<script>
export default {
  data(){
    return{
      img_src: {
        new1: 'https://s1.ax1x.com/2022/04/06/qXo4K0.jpg',
        new2: 'https://s1.ax1x.com/2022/04/06/qXofvq.jpg',
        new3: 'https://s1.ax1x.com/2022/04/06/qXo5rV.jpg',
        new4: 'https://s1.ax1x.com/2022/04/06/qXoW2n.jpg',
        new5: 'https://s1.ax1x.com/2022/04/06/qXoR8s.jpg',
        new6: 'https://s1.ax1x.com/2022/04/06/qXoIbT.jpg',
      }
    }
  }
}
</script>

<style lang="scss" scoped>
article {
  margin: 100px auto 50px;
  width: 800px;
}

h1 {
  margin-bottom: 30px;
  font-size: 30px;
}

p {
  line-height: 26px;
  text-indent: 30px;
}

img {
  width: 100%;
  margin: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/NewsDetail.vue